import { render, staticRenderFns } from "./chat_list.vue?vue&type=template&id=1d4bb1e1&scoped=true&"
import script from "./chat_list.vue?vue&type=script&lang=js&"
export * from "./chat_list.vue?vue&type=script&lang=js&"
import style0 from "./chat_list.vue?vue&type=style&index=0&id=1d4bb1e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4bb1e1",
  null
  
)

export default component.exports